import { render, staticRenderFns } from "./LogoAtex.vue?vue&type=template&id=18dcbb73&"
var script = {}


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\wamp64\\www\\4g22\\themes\\foreground-theme-2022\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('18dcbb73')) {
      api.createRecord('18dcbb73', component.options)
    } else {
      api.reload('18dcbb73', component.options)
    }
    module.hot.accept("./LogoAtex.vue?vue&type=template&id=18dcbb73&", function () {
      api.rerender('18dcbb73', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/svg/LogoAtex.vue"
export default component.exports